import { render } from "./MessageActionBar.vue?vue&type=template&id=5bc72304&scoped=true"
import script from "./MessageActionBar.vue?vue&type=script&lang=js"
export * from "./MessageActionBar.vue?vue&type=script&lang=js"

import "./MessageActionBar.vue?vue&type=style&index=0&id=5bc72304&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc72304"]])

export default __exports__